import { create } from 'zustand';

export type ConfigureScenarioStore = {
  isConfiguring: boolean;
  setIsConfiguring: (isConfiguring: boolean) => void;
};

export const useConfigureScenarioStore = create<ConfigureScenarioStore>((set) => ({
  isConfiguring: false,
  setIsConfiguring: (isConfiguring: boolean) => set({ isConfiguring }),
}));
